export type FileTransferTransport = 'online' | 'offline';

export class FileTransferRequestError extends Error {
  constructor(readonly resultCode: number) {
    super('File transfer request was rejected');
    this.name = 'FileTransferRequestError';
  }
}

export const OFFLINE_FILE_MAX_BYTES = 10 * 1024 * 1024;

export function getOfflineFileSizeError(fileSize: number): string | null {
  return fileSize > OFFLINE_FILE_MAX_BYTES
    ? '离线文件不能超过 10 MiB，请选择更小的文件'
    : null;
}

export type FileTransferDirection = 'upload' | 'download';
export type FileTransferStatus =
  | 'requested'
  | 'connecting'
  | 'waiting-peer'
  | 'available'
  | 'transferring'
  | 'completed'
  | 'failed';

export type FileTransferTask = {
  taskId: string;
  sha256?: string;
  /** Server-issued scoped ticket; never derive this from client task fields. */
  authTicket?: string;
  /** Device binding used for the file WebSocket login. */
  deviceId?: string;
  sessionKey: string;
  peerUserId: number;
  fileName: string;
  totalBytes: number;
  transferredBytes: number;
  direction: FileTransferDirection;
  transport: FileTransferTransport;
  status: FileTransferStatus;
  createdAt: number;
  updatedAt: number;
  message: string | null;
  canAccept: boolean;
  objectUrl: string | null;
};
